import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-nieuweproductenFR',
  templateUrl: '../../../../assets/html/fabrikanten_nieuweproductenFR.html',
  styleUrls: ['./nieuweproductenFR.component.css']
})
export class NieuweproductenFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
